import { formatUserFullname } from '@/helpers';
import { CustomUser } from '@/models/custom-user.model';
import router from '@/router';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';

const namespace: string = 'authentication';

@Component
export default class CustomNavbar extends Vue {

    @Getter('isAuthenticated', { namespace: 'authentication' }) public isAuthenticated: boolean;

    @Action('logout', { namespace: 'authentication' }) private logout: any;
    @Action('setLang', { namespace: 'global' }) public setLang: any;

    @State('user', { namespace: 'authentication' }) private user: CustomUser;

    get fullName() {
        return formatUserFullname(this.user);
    }

    public handleLogout() {
        this.logout().then(() => {
            router.push('/admin/login');
        });
    }
}

